'use client'
import React, { createContext, useContext } from 'react'
import { themes } from './themes'

type Theme = typeof themes.titan

const ThemeContext = createContext<Theme>(themes.titan)

export const ThemeProvider = ({
  children,
  theme
}: {
  children: React.ReactNode
  theme: Theme
}) => {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export const useTheme = () => useContext(ThemeContext)
